import { TOKEN_KEY } from "../settings/auth.ts";

function tryLocalStorageGet(key: string): string | null {
  try {
    // Works in window; in workers 'localStorage' won't exist.
    if (typeof globalThis !== "undefined" && "localStorage" in globalThis) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (globalThis as any).localStorage.getItem(key);
    }
  } catch {
    // ignore access errors (Safari ITP / privacy modes)
  }

  return null;
}

export function getCredentialsHeaders(): HeadersInit {
  const token = tryLocalStorageGet(TOKEN_KEY);
  return token
    ? {
        Authorization: `Bearer ${token}`,
        "X-Authorization": `Bearer ${token}`,
      }
    : {};
}
